module.exports = {
	"_args": [
		[
			"web3@1.0.0-beta.34",
			"/Users/Xander/Documents/fballcoin"
		]
	],
	"_from": "web3@1.0.0-beta.34",
	"_id": "web3@1.0.0-beta.34",
	"_inBundle": false,
	"_integrity": "sha1-NH5WG3hAmMtVYzFfSQR5odkfKrE=",
	"_location": "/web3",
	"_phantomChildren": {},
	"_requested": {
		"type": "version",
		"registry": true,
		"raw": "web3@1.0.0-beta.34",
		"name": "web3",
		"escapedName": "web3",
		"rawSpec": "1.0.0-beta.34",
		"saveSpec": null,
		"fetchSpec": "1.0.0-beta.34"
	},
	"_requiredBy": [
		"/",
		"/drizzle"
	],
	"_resolved": "https://registry.npmjs.org/web3/-/web3-1.0.0-beta.34.tgz",
	"_spec": "1.0.0-beta.34",
	"_where": "/Users/Xander/Documents/fballcoin",
	"author": {
		"name": "ethereum.org"
	},
	"authors": [
		{
			"name": "Fabian Vogelsteller",
			"email": "fabian@ethereum.org",
			"homepage": "http://frozeman.de"
		},
		{
			"name": "Marek Kotewicz",
			"email": "marek@parity.io",
			"url": "https://github.com/debris"
		},
		{
			"name": "Marian Oancea",
			"url": "https://github.com/cubedro"
		},
		{
			"name": "Gav Wood",
			"email": "g@parity.io",
			"homepage": "http://gavwood.com"
		},
		{
			"name": "Jeffery Wilcke",
			"email": "jeffrey.wilcke@ethereum.org",
			"url": "https://github.com/obscuren"
		}
	],
	"bugs": {
		"url": "https://github.com/ethereum/web3.js/issues"
	},
	"dependencies": {
		"web3-bzz": "1.0.0-beta.34",
		"web3-core": "1.0.0-beta.34",
		"web3-eth": "1.0.0-beta.34",
		"web3-eth-personal": "1.0.0-beta.34",
		"web3-net": "1.0.0-beta.34",
		"web3-shh": "1.0.0-beta.34",
		"web3-utils": "1.0.0-beta.34"
	},
	"description": "Ethereum JavaScript API",
	"keywords": [
		"Ethereum",
		"JavaScript",
		"API"
	],
	"license": "LGPL-3.0",
	"main": "src/index.js",
	"name": "web3",
	"namespace": "ethereum",
	"repository": {
		"type": "git",
		"url": "https://github.com/ethereum/web3.js/tree/master/packages/web3"
	},
	"types": "index.d.ts",
	"version": "1.0.0-beta.34"
};


//////////////////
// WEBPACK FOOTER
// ./~/web3/package.json
// module id = 543
// module chunks = 0